module.exports = __webpack_public_path__ + "img/AufDenPreisEinigen.3b790a78.jpg";